import React from 'react';
import { bool, number, shape } from 'prop-types';
import { Box, Typography, useTheme } from '@mui/material';
import { formatNumber } from 'utils/helpers/format';
import { limitTextStyles } from '../SupplierAuthCard.styles';

const SupplierAuthLimitRemainingVolume = ({ active, remainingVolumeData }) => {
  const { remainingVolume } = remainingVolumeData;
  const theme = useTheme();

  const remainingVolumeAmount =
    active && remainingVolume !== null ? `${formatNumber(remainingVolume)}` : 'N/A';

  const renderBody = () => {
    return (
      <Box
        alignItems="center"
        bgcolor={theme.palette.background.paper}
        border={`1px solid ${theme.palette.graphic.light}`}
        borderRadius={0.5}
        display="flex"
        flexDirection="column"
        height={64}
        justifyContent="center"
        mb={1}
        pb={1}
        pt={0.75}
      >
        <Typography sx={limitTextStyles({ limitMet: false, theme })} variant="subtitle1">
          {remainingVolumeAmount}
        </Typography>
        <Typography color={theme.palette.text.primary} variant="body2">
          Gallon Remaining Volume
        </Typography>
      </Box>
    );
  };

  return (
    <>
      {active ? (
        renderBody()
      ) : (
        <Box
          alignItems="center"
          border={`1px solid ${theme.palette.graphic.light}`}
          borderRadius="4px"
          display="flex"
          flexDirection="column"
          height={64}
          justifyContent="center"
          mb={1}
          pb={1}
          pt={0.75}
        >
          <Typography variant="subtitle1">N/A</Typography>
          <Typography color={theme.palette.text.primary} variant="body2">
            Gallon Remaining Volume
          </Typography>
        </Box>
      )}
    </>
  );
};

export default SupplierAuthLimitRemainingVolume;

SupplierAuthLimitRemainingVolume.propTypes = {
  active: bool.isRequired,
  remainingVolumeData: shape({
    remainingVolume: number,
  }),
};

SupplierAuthLimitRemainingVolume.defaultProps = {
  remainingVolumeData: {
    remainingVolume: null,
  },
};
